import { Component, Inject, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { DashboardFavourites } from '../../dashboard/dashboard.model';
import { FamilyList, JobsiteSelectionFilter, ModelSelectionFilter, SaveFavouritesParams, SaveFavouritesParamsDigitalForms } from '../../favourite-dialog/favourite-dialog-modal';
import { FavouriteDialogService } from '../../favourite-dialog/favourite-dialog.service';
import { CustomerSelectItem, EquipmentSelectItem } from '../../setup-equipment/setup-equipment.model';
import { GETSetupEquipmentService } from '../../setup-equipment/setup-equipment.service';
import { FormCatListVMSafety, GenericIdName } from '../../setup-implement/setup-implement.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-favourite-dialog-digital-form',
  templateUrl: './favourite-dialog-digital-form.component.html',
  styleUrls: ['./favourite-dialog-digital-form.component.scss']
})
export class FavouriteDialogDigitalFormComponent implements OnInit {

  favName: string
  favId: number = 0
  selectedCategory:number[]=[]
  selectedCustomer: number[] = []
  selectedJobsite: number[] = []
  selectedFamily: number[] = []
  selectedModel: number[] = []
  selectedEquipment: number[] = []
  selectedForms: number[] = []
  selectedInspectors: number[] = []
  selectedStatus: number[] = [];
  selectedDateRange:number[]=[]
  selectedDateRange_:number
  TypeID: number
  countdays:number;
  favouriteDetail: SaveFavouritesParamsDigitalForms

  formCatList: FormCatListVMSafety[] = [];
  formList: GenericIdName[] = [];
  familyList: FamilyList[] = [];
  modelList: GenericIdName[] = [];
  equipmentList: EquipmentSelectItem[] = [];
  inspectorList: GenericIdName[] = [];
  customerList: CustomerSelectItem[] = [];
  jobsiteList: GenericIdName[] = [];
  filteredFamilies:GenericIdName[]=[];
  dateRangetypes:GenericIdName[]=[];
  SetDefault=false
  constructor( public dialogRef: MatDialogRef<FavouriteDialogDigitalFormComponent>,  
     public _favouriteDialogService: FavouriteDialogService,
     private _equipmentService: GETSetupEquipmentService,
     public toastr: NotificationsService,
     @Inject(MAT_DIALOG_DATA) public data: any ) { }


  
  ngOnInit() {  
    this.favId = this.data.favouriteId;  
    if(this.favId>0){
      this. loadFavouriteDetailsById() 
    }
   
    this.loadCustomers();
    this.loadAllFamilyList(); 
    this.LoadInspectors();  
    this.loadFormCatList();
    console.log("favid", this.favId)
    if(this.favId==undefined){
  this.selectedStatus = [1, 2, 3]
    }
 
   
   this.loadModelList();
   this.loadJobsitesForCustomer();
  
this.LoadDateRangeTypes();
     
    this.TypeID = 3;
  }

  loadFavouriteDetailsById() {
    this._favouriteDialogService.LoadFavouriteDetails_DigitalForms(this.favId).subscribe(r => {
      this.favouriteDetail = r;
      this.selectedCategory=r.FormCategories
      this.selectedCustomer = r.Customers;
      this.selectedJobsite = r.Jobsites;
      this.TypeID = r.DefaultView;
      this.selectedFamily = r.Families;
      this.favName = r.FavouriteName;    
      this.selectedModel = r.Models;
      this.selectedEquipment=r.Machines;
      this.selectedForms=r.FormNames;
      this.selectedInspectors=r.Inspectors;
      this.selectedStatus=r.Status;
      this.selectedDateRange_=r.dateRange_;
      this.SetDefault=r.isDefaultFav;

      
      
    })

  }
  
  loadFormCatList() {
    this._favouriteDialogService.getFormCategoryListForSafety().subscribe(result => {
      this.formCatList = result

        if (this.selectedCategory.length > 0) {
          console.log(this.selectedCategory)
          this.LoadForms();
        }
      

     
    })
  }
  loadAllFamilyList(){
    this._favouriteDialogService.getllFamilyList().subscribe(res=>{
      this.familyList =res;
    })
  }

  loadJobsitesForCustomer() {
    if (this.selectedCustomer == null)
      return;
    this.selectedJobsite = null;
    this.jobsiteList = null;
    this.selectedEquipment = null;
    this.equipmentList = [];
    var params: JobsiteSelectionFilter = {
      Customers: this.selectedCustomer,
    }
    this._favouriteDialogService.GetjobsitesAvailable(params).subscribe(r => {
      if (r) {
        console.log("data_",r,this.favouriteDetail)
        this.jobsiteList = r;
if(this.favouriteDetail.Jobsites.length>0){
this.selectedJobsite = this.favouriteDetail.Jobsites;
    this.loadEquipmentForJobsite();
  
}
         
          
        
      }
    });
  }

  loadEquipmentForJobsite() {
    if (this.selectedJobsite == null)
      return;
    var params: number[] = this.selectedJobsite;
    this._favouriteDialogService.GetEquipmentAvailable(params).subscribe(r => {
      if (r) {
        this.equipmentList = r;
        if(this.favouriteDetail.Machines.length>0){
          this.selectedEquipment = this.favouriteDetail.Machines;
        }
      }
    });
  }
  LoadForms() {
    this._favouriteDialogService.GetFormListAvailable(this.selectedCategory).subscribe(res => {
      this.formList = res;

      if(this.favouriteDetail.FormNames.length>0){
        this.selectedForms = this.favouriteDetail.FormNames;
      }
      // if(this.CategoryIds.length>0){
        
      //   this.countdays = this.formCatList.find(x=>x.Id==this.CategoryIds[0]).Days;
      //   console.log("chnages_", this.countdays,this.formCatList)
      //   this.startDate = new Date(new Date().setDate(new Date().getDate() - this.countdays));
      // }else{
      //   this.startDate = this.defaultSearchStartDate;
      //   this.endDate=this.defaultSearchEndDate;
      // }
    })
  }

  LoadInspectors() {
    this._favouriteDialogService.GetInspectorAvailable().subscribe(r => {
      if (r) {
        this.inspectorList = r;
      }
    });
  }

  loadModelList() {
    this.modelList = null
    var params: ModelSelectionFilter = {
      Families: this.selectedFamily,
      Makes: []
    }
    this._favouriteDialogService.GetModelsAvailable(params).subscribe(r => {
      if (r) {
        this.modelList = r;
      }
    });

  }
  

  loadCustomers() {
    this.familyList  = this. _favouriteDialogService.availableFamilyList 
    this._equipmentService.getCustomerList().subscribe(r => {
      this.customerList = r;
      if(this.favouriteDetail.Customers.length>0){
        this.selectedCustomer = this.favouriteDetail.Customers;
          this.loadJobsitesForCustomer();
        }
      
      
        
      
    });
  }
  


  loadFamiliesForCustomer(){
    var params: JobsiteSelectionFilter = {
      Customers: this.selectedCustomer,
    }
    if(this.selectedCustomer.length>0){
      this._favouriteDialogService.GetFamiliesForSelectedCustomers(params).subscribe(r => {
        if (r) {
          this.filteredFamilies = r;
          if (this.filteredFamilies.length>0) {
          
            this.familyList = this.filteredFamilies;//this.familyList.filter(x=>)
          }else{
            this.familyList  = this. _favouriteDialogService.availableFamilyList 
          }
        }
      });
    }else{
      this.loadAllFamilyList();
    }
    
  }


 
  
  SaveFavouriteDigitalFormSearch() {

    if (this.favName == "" || this.favName == null) {
      this.toastr.error("Please enter Favourite name.");
    }
    else {
      var params: SaveFavouritesParamsDigitalForms = {
        FavouriteName: this.favName,
        DefaultView: this.TypeID,
        Customers: this.selectedCustomer,
        Jobsites: this.selectedJobsite,
        Families: this.selectedFamily,
        Models: this.selectedModel,
        FormCategories:this.selectedCategory,
        Machines:this.selectedEquipment != null ?this.selectedEquipment:[] ,
        FormNames:this.selectedForms,
        Inspectors:this.selectedInspectors,
        Status:this.selectedStatus,
        dateRange:this.selectedDateRange,
        dateRange_:this.selectedDateRange_,
        FavouriteId: 0,
        isDefaultFav:this.SetDefault,
        
      }
      this._favouriteDialogService.SaveFavouriteDigitalFormSearch(params).subscribe(r => {
        if (r == 0) {
          this.toastr.error("Favourite name already exsist");
        }
        else if (r == 1) {
          this.toastr.success("Saved successfully");
          this.dialogRef.close({});
        }
        else {
          this.toastr.error("There was an error saving these changes.");
        }
      })
    }

  }


  UpdateFavourite() {
  
    if (this.favName == "" || this.favName == null) {
      this.toastr.error("Please enter Favourite name.");
    }
    else {
      var params: SaveFavouritesParamsDigitalForms = {
        FavouriteName: this.favName,
        DefaultView: this.TypeID,
        Customers: this.selectedCustomer,
        Jobsites: this.selectedJobsite,//this.selectedJobsite = null? this.selectedJobsite :[],
        Families: this.selectedFamily,
        Models: this.selectedModel,
        FormCategories:this.selectedCategory,
        Machines:this.selectedEquipment!= null ?this.selectedEquipment:[],
        FormNames:this.selectedForms,
        Inspectors:this.selectedInspectors,
        Status:this.selectedStatus,
        FavouriteId: this.favId,
        dateRange:this.selectedDateRange,
        dateRange_:this.selectedDateRange_,
        isDefaultFav:this.SetDefault,
       
      }
      this._favouriteDialogService.UpdateFavouriteDigitalForm(params).subscribe(r => {
        if (r == 0) {
          this.toastr.error("Failed to update the favourite details");
        }
        else if (r == 1) {
          this.toastr.success("Updated successfully");
          this.dialogRef.close({});
        }
        else {
          this.toastr.error("There was an error saving these changes.");
        }
      })
    }

  }

  LoadDateRangeTypes() {
    this._favouriteDialogService.GetCustomDateRangeTypes().subscribe(r => {
      if (r) {
        this.dateRangetypes = r;
      }
    });
  }

  ChangeCustomeDateType(date){
   this.selectedDateRange=[]
   if(date !=undefined){
    this.selectedDateRange.push(date)
   }
  }

  changeCheckbox(){
    this.SetDefault=!this.SetDefault
    console.log(this.SetDefault)
  }
  onCloseClick(): void {
    this.dialogRef.close({});
  }

}



  
